import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { generateReport } from '../../app/store/actions/reports';
import FilterDefault from '../../components/filters/FilterDefault';
import OneClickButton from '../../components/form/button';
import Form from '../../components/form/form';
import DualList from '../../components/pages/DualList';
import { PanelPage } from '../../components/pages/pages';
import { returnFiltersByRules } from './utils';
import ROUTES from '../../config/routes';
import ReportsBackgroundModal from '../../components/pages/reportsBackgroundModal';

class ReportRegistrationGeneralTypeAddress extends React.PureComponent {
  constructor() {
    super();

    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {' '}
            { I18n.t('BEE12' /* Início */)}
          </>
        ),
      },
      { value: I18n.t('BEE47' /* Relatórios */) },
      { value: I18n.t('BEE1389' /* Cadastros */) },
      { value: I18n.t('BEE14' /* Gerais */) },
      { value: I18n.t('BEE732' /* Tipos de Endereço */), active: true },
    ];

    this.options = [
      {
        label: I18n.t('BEE82' /* Código */),
        value: 'code',
      }, {
        label: I18n.t('BEE83' /* Nome */),
        value: 'name',
      }, {
        label: I18n.t('BEE224' /* Status */),
        value: 'status',
      }, {
        label: I18n.t('BEE135' /* Observação */),
        value: 'note',
      }, {
        label: I18n.t('BEE575' /* Usuário de criação */),
        value: 'createdUser',
      }, {
        label: I18n.t('BEE578' /* Data de criação */),
        value: 'createdAt',
      }, {
        label: I18n.t('BEE576' /* Usuário de alteração */),
        value: 'updatedUser',
      }, {
        label: I18n.t('BEE577' /* Data de alteração */),
        value: 'updatedAt',
      },
    ];

    this.state = {
      selected: [],
      codeFrom: '',
      codeTo: '',
      noteFrom: '',
      noteTo: '',
      checkAllCheckBoxes: true,
      normal: true,
      surplus: true,
      reserve: true,
      picking: true,
      rejected: true,
      damage: true,
      lack: true,
      preStorageStage: true,
      separationStage: true,
      crossdocking: true,
    };
  }

  onChangeDualList = (selected) => {
    this.setState({ selected });
  };

  checkOrUncheckAllBoxes = (value) => {
    this.setState({
      normal: value,
      surplus: value,
      reserve: value,
      picking: value,
      rejected: value,
      damage: value,
      lack: value,
      preStorageStage: value,
      separationStage: value,
      crossdocking: value,
      checkAllCheckBoxes: value,
    });
  };

  handleSelectAllCheckBox = () => {
    if (this.state.normal
      && this.state.surplus
      && this.state.reserve
      && this.state.picking
      && this.state.rejected
      && this.state.damage
      && this.state.lack
      && this.state.preStorageStage
      && this.state.separationStage
      && this.state.crossdocking) {
      this.setState({
        checkAllCheckBoxes: true,
      });
    } else {
      this.setState({
        checkAllCheckBoxes: false,
      });
    }
  };

  setValue = async (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
    if (attr === 'checkAllCheckBoxes') {
      this.handleSelectAllCheckBox();
      this.checkOrUncheckAllBoxes(value);
    }
  };

  onGenerateSpreadsheet = () => {
    const {
      selected,
      codeFrom,
      codeTo,
      noteFrom,
      noteTo,
      normal,
      surplus,
      reserve,
      picking,
      rejected,
      damage,
      lack,
      preStorageStage,
      separationStage,
      crossdocking,
    } = this.state;
    const { location } = this.props;

    const headers = selected.map((it) => ({ ...(this.options.find((itb) => itb.value === it) || {}) }));

    const status = ['0'];
    if (normal) status.push('1');
    if (surplus) status.push('2');
    if (reserve) status.push('3');
    if (picking) status.push('4');
    if (rejected) status.push('5');
    if (damage) status.push('6');
    if (lack) status.push('7');
    if (preStorageStage) status.push('8');
    if (separationStage) status.push('9');
    if (crossdocking) status.push('10');

    const filters = returnFiltersByRules([
      ['code', { type: 'between', value: [codeFrom.toLocaleUpperCase(), codeTo.toLocaleUpperCase()] }],
      ['note', { type: 'between', value: [noteFrom, noteTo] }],
      ['status', { type: 'in', value: status }],
    ]);

    this.props.generateReport(
      I18n.t('BEE732' /* Tipos de Endereço */).toLowerCase(),
      'xlsx',
      location.pathname,
      headers,
      filters,
    );
  };

  onSelectFilter = (newState) => this.setState({ ...newState });

  render() {
    const {
      selected,
      codeFrom,
      codeTo,
      noteFrom,
      noteTo,
      checkAllCheckBoxes,
      normal,
      surplus,
      reserve,
      picking,
      rejected,
      damage,
      lack,
      preStorageStage,
      separationStage,
      crossdocking,
    } = this.state;

    const { location = {} } = this.props;

    return (
      <PanelPage
        breadcrumb={this.breadcrumb}
        title={`${I18n.t('BEE528' /* Relatório */)} - ${I18n.t('BEE732' /* Tipos de Endereço */)}`}
        wikiHelp={ROUTES.REPORT_HELP}
        content={(
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            <FilterDefault stateToSave={this.state} route={location.pathname} onSelectFilter={this.onSelectFilter} />
            <div className="d-flex mb-md-4 mb-4 mt-4" />
            <DualList
              id="dualselect"
              options={this.options}
              selected={selected}
              onChange={this.onChangeDualList}
              preserveSelectOrder
              showOrderButtons
              showHeaderLabels
            />
            <div className="d-flex align-items-center mb-md-3 mb-1 mt-5">
              <h1 className="page-header mb-0">
                {I18n.t('BEE546' /* Filtros */)}
              </h1>
            </div>
            <hr />
            <div style={{ marginTop: 30 }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createInputRange(
                    { from: codeFrom.toLocaleUpperCase(), to: codeTo.toLocaleUpperCase() },
                    { from: 'codeFrom', to: 'codeTo' },
                    `${I18n.t('BEE82' /* Código */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: noteFrom, to: noteTo },
                    { from: 'noteFrom', to: 'noteTo' },
                    `${I18n.t('BEE277' /* Descrição */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ),
                  formContext.createCheckBoxes([
                    {
                      attr: 'checkAllCheckBoxes',
                      value: checkAllCheckBoxes,
                      label: I18n.t('BEE2385' /* Marcar ou Desmarcar todos */),
                    },
                    {
                      label: I18n.t('BEE733' /* Normal */),
                      value: normal,
                      attr: 'normal',
                    }, {
                      label: I18n.t('BEE734' /* Excelente */),
                      value: surplus,
                      attr: 'surplus',
                    }, {
                      label: I18n.t('BEE735' /* Reserva */),
                      value: reserve,
                      attr: 'reserve',
                    }, {
                      label: I18n.t('BEE736' /* Picking */),
                      value: picking,
                      attr: 'picking',
                    }, {
                      label: I18n.t('BEE177' /* Rejeitados */),
                      value: rejected,
                      attr: 'rejected',
                    }, {
                      label: I18n.t('BEE573' /* Avaria */),
                      value: damage,
                      attr: 'damage',
                    }, {
                      label: I18n.t('BEE2238' /* Falta */),
                      value: lack,
                      attr: 'lack',
                    }, {
                      label: I18n.t('BEE3495' /* Stage Pré-Armazenagem */),
                      value: preStorageStage,
                      attr: 'preStorageStage',
                    }, {
                      label: I18n.t('BEE3589' /* Stage de Separação */),
                      value: separationStage,
                      attr: 'separationStage',
                    }, {
                      label: I18n.t('BEE4347' /* Cross-Docking */),
                      value: crossdocking,
                      attr: 'crossdocking',
                    },
                  ], `${I18n.t('BEE224' /* Status */)}:`),
                ])}
              />
            </div>
            <ReportsBackgroundModal />
          </div>
                )}
        footerContent={(
          <OneClickButton
            type="button"
            style={{ width: 'auto', padding: 10 }}
            className="btn btn-primary p-5 m-5"
            onClick={this.onGenerateSpreadsheet}
          >
            {I18n.t('BEE544' /* Gerar Planilha */)}
          </OneClickButton>
                )}
      />
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  generateReport: (
    nameDoc,
    type,
    route,
    columns,
    filters,
  ) => dispatch(generateReport(nameDoc, type, route, columns, filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportRegistrationGeneralTypeAddress);
